"use client";

import { useAppSelector } from "@v2/lib/redux/hooks";
import Box from "@mui/material/Box";
import Link from "next/link";
import { LayoutPanelTopIcon, ScanSearchIcon } from "lucide-react";
import { usePathname } from "next/navigation";

const PORTAL_URL = process.env.NEXT_PUBLIC_PORTAL_URL ?? "https://portal.vahdatoptic.com";
const APP_URL = process.env.NEXT_PUBLIC_APP_URL ?? "https://vahdatoptic.com";

export default function AdminBar() {
    const actions = useAppSelector((s) => s.adminBar.actions);
    const pathname = usePathname();
    const inspectHref = `${PORTAL_URL}/inspect?url=${encodeURIComponent(APP_URL + pathname)}`;

    return (
        <Box
            id="top-bar"
            sx={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                zIndex: 1100,
                bgcolor: "#1a1a2e",
                height: 36,
                display: "flex",
                alignItems: "center",
            }}
        >
            <Box sx={{ maxWidth: 1400, width: 1, mx: "auto", px: 2, display: "flex", alignItems: "center", gap: 2, boxSizing: "content-box" }}>
                <Box
                    component={Link}
                    href={PORTAL_URL}
                    target="_blank"
                    sx={{ display: "flex", alignItems: "center", gap: 0.75, color: "#7c83fd", fontSize: 12, textDecoration: "none", "&:hover": { color: "#a5aaff" } }}
                >
                    <LayoutPanelTopIcon size={13} />
                    <span>پنل مدیریت</span>
                </Box>

                <Box sx={{ width: "1px", height: 14, bgcolor: "rgba(255,255,255,0.15)" }} />

                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    {actions.map((action) => (
                        <Box
                            key={action.href}
                            component={Link}
                            href={action.href}
                            target={action.sameTab ? undefined : "_blank"}
                            sx={{
                                color: "#e0e0e0",
                                fontSize: 12,
                                textDecoration: "none",
                                px: 1.5,
                                py: 0.5,
                                borderRadius: 1,
                                transition: "background 0.2s",
                                "&:hover": { bgcolor: "rgba(255,255,255,0.1)", color: "#fff" },
                            }}
                        >
                            {action.label}
                        </Box>
                    ))}
                </Box>

                <Box
                    component={Link}
                    href={inspectHref}
                    target="_blank"
                    sx={{
                        ml: "auto",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        textDecoration: "none",
                        flexShrink: 0,
                        transition: "opacity 0.2s",
                        "&:hover": { opacity: 0.75 },
                    }}
                >
                    <Box sx={{ color: "#aaa", fontSize: 11 }}>Inspect URL</Box>
                    <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 28,
                        height: 28,
                        borderRadius: 1,
                        bgcolor: "#fff",
                        color: "#1a1a2e",
                        flexShrink: 0,
                    }}>
                        <ScanSearchIcon size={15} />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
